import React, { useState, useEffect } from 'react';
import { InputLabel, Typography } from '@mui/material';
import { useField, useFormikContext } from 'formik';
import PhoneInput from 'react-phone-input-2';
import { searchCustomers } from '../../../services/user';
import 'react-phone-input-2/lib/style.css';
import { cx } from '../../../helpers/global';
import './style.css';

interface Props {
  name: string;
  label: string;
  placeholder: string | undefined;
  search: boolean;
  disabled: boolean;
}

export default function StyledPhoneInput({
  name,
  label,
  placeholder,
  search,
  disabled,
}: Props) {
  const { setFieldValue } = useFormikContext();
  const [{ value: phoneNumber }, { error, touched }, { setValue, setTouched }] =
    useField(name);

  const [valueSet, setValueSet] = useState(false);

  useEffect(() => {
    async function fetchCustomer() {
      // Freeze the page loading state

      // Search for the customer
      const customer = await searchCustomers(phoneNumber);

      // Autofill form values
      if (customer && customer[0]) {
        setFieldValue('firstName', customer[0].firstName);
        setFieldValue('lastName', customer[0].lastName);
        setFieldValue('email', customer[0].email);
        setFieldValue('customerId', customer[0].userId);
      }
    }

    if (phoneNumber && phoneNumber.length === 11 && search) {
      fetchCustomer();
    }
  }, [setFieldValue, phoneNumber, search]);

  const onBlur = React.useCallback(() => {
    setTouched(true);
  }, [setTouched]);

  const isError = touched && !!error;

  return (
    <div
      className={cx('input', 'phone-input', isError && 'error')}
      style={{ position: 'relative' }}>
      <InputLabel htmlFor={name}>
        <Typography variant="h5">{label}</Typography>
      </InputLabel>
      <PhoneInput
        placeholder={placeholder}
        country="us"
        value={phoneNumber}
        onChange={val => {
          const cleanedVal = val.replace(/\D/g, '');
          setValue(cleanedVal);
          setValueSet(true);
        }}
        disabled={disabled}
        disableDropdown={disabled}
        onBlur={onBlur}
      />
      {!phoneNumber && !valueSet && (
        <Typography
          variant="body2"
          className="phone-number-placeholder"
          style={{
            position: 'absolute',
            top: 17,
            left: 260,
            color: '#B5B5B5',
          }}>
          {search ? 'Select or create a customer' : 'Phone Number'}
        </Typography>
      )}
    </div>
  );
}
